import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";

import { DfpComponent } from "./dfp-component";
import useDevice from "../helper/custom-hook/useDevice";
import { WithLazy } from "@quintype/components";
import { getSectionSlug } from "./utils";

import "./ads.m.css";

const AdSlot = ({ id, ad_type, adStyleName = "", isExternalAdPath = false }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const isAdfree = get(qtState, ["config", "subscriber"]) === "true";
  const networkId = get(qtState, ["config", "ads-config", "network_id"], "");
  const adConfig = get(qtState, ["config", "ads-config", "slots", ad_type], {});
  const { sizes, ad_unit, view_port_size_mapping, externalPath } = adConfig;
  const adUnitPath = isExternalAdPath ? externalPath : `${networkId}/${ad_unit}`;

  const DfpComponentWrapper = () => (
    isAdfree ? null : <DfpComponent
      adStyleName={adStyleName}
      id={id}
      path={adUnitPath}
      size={sizes}
      viewPortSizeMapping={view_port_size_mapping}
      type="top-ad"
    />
  );

  if (
    ad_unit === "PV_MWeb_AP_Mid" ||
    ad_unit === "PV_Desktop_AP_Mid" ||
    ad_unit === "PV_Desktop_AP_Mid_02" ||
    ad_unit === "PV_MWeb_AT_Mid02" ||
    ad_unit === "PV_Mweb_AT_Top_300x250" ||
    ad_unit === "PV_Mweb_HP_Sticky" ||
    ad_unit === "PV_Mweb_AP_Sticky" ||
    ad_unit === "PV_Mweb_AP_Sticky_ym"
  ) {
    return <DfpComponentWrapper />;
  }
  return <WithLazy>{() => <DfpComponentWrapper />}</WithLazy>;
};

const AdContainer = React.memo(
  ({ id, desktop, mobile, AdClassName = "", showText = true, isExternalAdPath = false, cta = "sidebar" }) => {
    const qtState = useSelector((state) => get(state, ["qt"], {}));
    const isAdfree = get(qtState, ["config", "subscriber"]) === "true";
    const subscriptionConfig = get(qtState, ["data", "subscriptionConfig", "ad-lite-cta"], {});
    return (
      isAdfree ? <></> : <div styleName="ad-container">
        {showText ?
          <span styleName="ad-text" className="ad-text">{cta === "inStory" ? subscriptionConfig?.["inStory-text"] || "ಲೇಖನವು ಕೆಳಗೆ ಮುಂದುವರಿಯುತ್ತದೆ. " : subscriptionConfig?.["advertisment-text"] || "ಜಾಹೀರಾತು. "}
            <a
              styleName="ad-text red-text"
              className="ad-text"
              href="/subscribe?utm_source=pv_site&utm_medium=ad_cta&utm_campaign=pv_subscription"
              style={{ textDecoration: "underline" }}
              onClick={(e) => {
                e.preventDefault();
                if (window) {
                  const { getAuthStatus } = require("../helper/datalayer-utils");
                  const { status, uuid } = getAuthStatus();
                  const formattedStatus = status === "not_logged_in" ? "non_logged_in" : status;

                  let slotName = desktop || mobile || id || "NA";
                  if (typeof slotName === "string" && slotName.includes("/")) {
                    const parts = slotName.split("/");
                    slotName = parts[parts.length - 1];
                  }

                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: "ad_lite_button_click",
                    ad_slot_name: slotName,
                    auth_status: formattedStatus,
                    uuid: uuid
                  });
                }
                setTimeout(() => {
                  window.location.assign("/subscribe?utm_source=pv_site&utm_medium=ad_cta&utm_campaign=pv_subscription");
                }, 300);
              }}
            >
              {subscriptionConfig?.["cta-text"] || "Go Ad Lite"}
            </a>
          </span>
          : null}

        <div className="ad-background" styleName={`ad-background ${AdClassName}`}>
          {global.width >= 768 && desktop ? (
            <div styleName="desktop">
              <AdSlot id={`${id}`} ad_type={desktop} isExternalAdPath={isExternalAdPath} />
            </div>
          ) : null}

          {global.width <= 768 && mobile ? (
            <div styleName="mobile">
              <AdSlot id={`${id}`} ad_type={mobile} isExternalAdPath={isExternalAdPath} />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
);

const HeaderDesktopAd = () => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const isAdfree = get(qtState, ["config", "subscriber"]) === "true";
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], "home-page"));
  const adsId = {
    // "home-page": "div-gpt-ad-1675836701321-0",
    // "story-page": "div-gpt-ad-1675837096352-0",
    "izooto-top": "div-gpt-ad-1711630530156-0"
  };
  const ads = {
    // "home-page": "PV_Desktop_HP_Display_Leaderboard_Top",
    // "story-page": "PV_Desktop_AP_Leaderboard_Top",
    "izooto-top": "PV_Desktop_AP_LB_Top_ym"
  };

  const [adType, setAdType] = useState("");

  useEffect(() => {
    try {
      const searchParams = new URLSearchParams(window.location.search);
      const utmSource = searchParams.get("utm_source");
      if (utmSource === "izooto") {
        setAdType("izooto");
      }
    } catch (e) { }
  }, []);

  return null;
  // <div>
  //   <AdContainer
  //     AdClassName="standard-970x90"
  //     id={adType === "izooto" ? adsId["izooto-top"] : adsId[pageType] || "div-gpt-ad-1675836701321-0"}
  //     desktop={adType === "izooto" ? ads["izooto-top"] : ads[pageType] || "PV_Desktop_HP_Display_Leaderboard_Top"}
  //     isExternalAdPath={adType === "izooto" ? true : false}
  //   />
  // </div>
};

const OutOfPageAd = () => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const isAdfree = get(qtState, ["config", "subscriber"]) === "true";
  const isMobile = useDevice();

  if (isAdfree) return null;

  return (
    <>
      {isMobile ? (
        <>
          <AdContainer
            className="hide-desktop"
            showText={false}
            id="div-gpt-ad-1787043010215-0"
            mobile="PV_mweb_slider"
          />
          <AdContainer
            className="hide-desktop"
            showText={false}
            id="div-gpt-ad-1675937438395-0"
            mobile="PV_Mobile_Interstial"
          />
        </>
      ) : (
        <AdContainer
          className="hide-mobile"
          showText={false}
          id="div-gpt-ad-1675937467341-0"
          desktop="PV_Desktop_Interstial"
        />
      )}
    </>
  );
};

export { AdSlot, AdContainer, HeaderDesktopAd, OutOfPageAd };
